import { Injectable } from '@angular/core';
import {
  Card, CardDetailedInformation, CardStocks, CardStocksDetails, Language,
  Warehouse
} from '../core/entities/entities';
import * as Rx from 'rxjs/Rx';
import {HttpService} from '../core/services/http.service';
import {HttpServiceBase} from '../core/services/HttpServiceBase';
import {isNullOrUndefined} from 'util';
import * as lodash from 'lodash';

import {Observable} from 'rxjs/Observable';
import {CardConditionService} from './card-condition.service';
import {WarehouseService} from './warehouse.service';
import {LanguageService} from './language.service';


@Injectable()
export class CardStockService extends HttpServiceBase<CardDetailedInformation> {

  getUrl() {
    return  'cardstocks/details/';
  }

  protected init(): void {
  }

  public fromJson(json): CardDetailedInformation {
    const me = this;
    const item: CardDetailedInformation = Object.assign(this.getCleanInstance(), json);

    if(item.stockDetailsList){
      item.stockDetailsList.forEach((sd, idx) => {
        this.languageService.loadById(sd.language_id).subscribe( i=>sd.language =i);
        this.warehouseService.loadById(sd.warehouse_id).subscribe( i=> sd.warehouse =i );
        this.cardCondService.loadById(sd.card_condition_id).subscribe( i=> sd.condition =i );
      } );
    }
    return item;
  }

  public getCleanInstance(): CardDetailedInformation {
    return <CardDetailedInformation>{};
  }
  constructor(protected http: HttpService, private cardCondService: CardConditionService, private warehouseService: WarehouseService, private languageService: LanguageService  ) {
    super(http);
  }

  getDetail(cardId: string, filters?: {}): Observable<CardDetailedInformation> {
    const me = this;
    let url = me._url + cardId;

    if( filters){
      filters =  Object.keys(filters)
        .filter(k => !isNullOrUndefined(filters[k]) && 'null' != filters[k] && 'undefined' != filters[k] )
        .reduce((previousValue, k) => {
          previousValue[k]=filters[k];
          return previousValue;
        },{});
    }

    if(filters && Object.keys(filters)){
      url += '/filter';
    }

    return Rx.Observable.create((observer: any) => {
      me.httpCall('get', url, {params: filters}).subscribe(ret =>  observer.next(me.fromJson(ret || null)));
    });
  }

}




// WEBPACK FOOTER //
// ./src/app/services/card-stock.service.ts